import React, { useState } from "react";
import { LayoutGrid, Rows3, Search } from "lucide-react";

import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

interface Props {
  onSearchChange: (value: string) => void;
  onVisualizationChange: (value: string) => void;
  active: string;
  searchBarDisabled: boolean;
}

export default function Filters({
  onSearchChange,
  onVisualizationChange,
  searchBarDisabled,
  active,
}: Props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <div className="flex flex-col gap-3">
      <label className="flex items-center gap-2 rounded-2xl border border-white/15 bg-white/5 px-4 py-2 text-sm text-white/80">
        <Search className="h-4 w-4 text-white/60" />
        <Input
          disabled={searchBarDisabled}
          placeholder="Buscar por nome, telefone ou destino"
          className="border-0 bg-transparent px-0 text-white placeholder:text-white/50 focus-visible:ring-0"
          onFocus={() => setTooltipOpen(true)}
          onBlur={() => setTooltipOpen(false)}
          onChange={(ev) => onSearchChange(ev.target.value)}
        />
      </label>
      {tooltipOpen && !searchBarDisabled && (
        <p className="text-xs text-white/60">Digite qualquer termo: nome, telefone, origem ou destino.</p>
      )}
      <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 p-1">
        <Button
          variant={active === "card" ? "default" : "ghost"}
          className={active === "card" ? "bg-white text-slate-900" : "text-white"}
          onClick={() => onVisualizationChange("card")}
        >
          <LayoutGrid className="mr-2 h-4 w-4" /> Cartões
        </Button>
        <Button
          variant={active === "table" ? "default" : "ghost"}
          className={active === "table" ? "bg-white text-slate-900" : "text-white"}
          onClick={() => onVisualizationChange("table")}
        >
          <Rows3 className="mr-2 h-4 w-4" /> Tabela
        </Button>
      </div>
    </div>
  );
}
